import React, { Component } from 'react';
import PropTypes from 'prop-types';

// http://codepen.io/chriscoyier/pen/FtnAa?editors=1111
// https://www.w3.org/TR/html-markup/input.range.html
export class ScaledSlider extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        return (this.props.additionalClassName !== nextProps.additionalClassName) ||
               (this.props.value !== nextProps.value) ||
               (this.props.ticks !== nextProps.ticks);
    }

    render() {
        const props = this.props;

        const tickMarks = [];
        for (var i = 0; i < props.ticks.length; i++) {
            if (i === 0) {
                tickMarks.push(<span key={i}/>);
            } else {
                let tickValue = props.ticks[i];
                tickMarks.push(
                    <span
                        style={{cursor: 'pointer'}}
                        className={"tick-mark no-select " + (tickValue <= props.value ? "" : "tick-inactive") }
                        key={i}
                        onClick={ function() {
                            props.handleChange(tickValue);
                        }}
                    >
                        <span className="tick-value">
                            { props.formattingFunction(tickValue) }{(i === props.ticks.length - 1) ? '+' : ''}
                        </span>
                    </span>
                )
            }
        }

        var sliderLower = (props.scaleHandler.toSliderScale(props.ticks, props.value) / (props.ticks.length - 1)) * 100;

        return (
            <span className={"scaled-slider " + props.additionalClassName}>
                <input className="scaled-slider-input"
                    type="range"
                    min={ 0 }
                    max={ props.ticks.length - 1 }
                    onChange={ function(event) {
                        props.handleChange(props.scaleHandler.fromSliderScale(props.ticks, parseFloat(event.target.value)));
                    }}
                    value={ props.scaleHandler.toSliderScale(props.ticks, props.value) }
                    step="any"
                />
                <div className="scaled-slider-upper">
                </div>
                <div className="scaled-slider-lower" style={{ width: sliderLower + '%' }}>
                </div>
                <span className="tick-wrapper">
                    <span className="tick-marks">
                        { tickMarks }
                    </span>
                </span>
            </span>
        );
    }
}

ScaledSlider.propTypes = {
    additionalClassName: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    ticks: PropTypes.array.isRequired,
    scaleHandler: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    formattingFunction: PropTypes.func.isRequired
};

export default ScaledSlider;